import { render } from "./SharedProfileDataEdit.vue?vue&type=template&id=58698487"
import script from "./SharedProfileDataEdit.vue?vue&type=script&lang=js"
export * from "./SharedProfileDataEdit.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__